import { useEffect, useMemo } from 'react';
import { API } from '../api/api';
import { computeProgress, yearPct } from '../utils/progress';

const REPORT_DEBOUNCE_MS = 5000;

// Progression af klientens egne events. Rank og leaderboard hentes i useLeaderboard.
export function useProgress({ events, weekNorm, isOutlookSyncEvent, isBillableEvent }) {
  const progress = useMemo(
    () => computeProgress({ events, weekNorm, now: new Date(), isOutlookSyncEvent, isBillableEvent }),
    [events, weekNorm, isOutlookSyncEvent, isBillableEvent],
  );

  // Melder level, procent og XP til leaderboardet, når de ændrer sig. Debounced, så en events-liste
  // der stadig er ved at indlæse ikke overskriver et rigtigt tal. Uden logs meldes der intet.
  const { level, xp } = progress;
  const pct = yearPct(xp);
  const hasEvents = (events || []).length > 0;
  useEffect(() => {
    if (!hasEvents) return undefined;
    const id = setTimeout(() => { API.reportProgress({ level, pct, xp }).catch(() => {}); }, REPORT_DEBOUNCE_MS);
    return () => clearTimeout(id);
  }, [level, pct, xp, hasEvents]);

  return { progress };
}
